﻿/**
 * Mapping from old station base names (stored as `city` in legacy etudes)
 * to the new dÃ©partement and ville values.
 */
const STATION_MAPPING: Record<string, { departement: string; ville: string }> = {
    "01-AMBERIEU": { departement: "Ain", ville: "Amberieu-en-Bugey" },
    "02-EPARCY": { departement: "Aisne", ville: "Eparcy" },
    "02-ST_QUENTIN": { departement: "Aisne", ville: "Saint-Quentin" },
    "03-VICHY": { departement: "Allier", ville: "Vichy" },
    "04-ALLOS": { departement: "Alpes-de-Haute-Provence", ville: "Allos" },
    "05-EMBRUN": { departement: "Hautes-Alpes", ville: "Embrun" },
    "05-GAP": { departement: "Hautes-Alpes", ville: "Gap" },
    "05-LARAGNE": { departement: "Hautes-Alpes", ville: "Laragne-Monteglin" },
    "06-ANDON-BAS_THORENC": { departement: "Alpes-Maritimes", ville: "Andon" },
    "06-BREIL_SUR_ROYA": { departement: "Alpes-Maritimes", ville: "Breil-sur-Roya" },
    "06-GRASSE": { departement: "Alpes-Maritimes", ville: "Grasse" },
    "06-ISOLA": { departement: "Alpes-Maritimes", ville: "Isola" },
    "06-NICE": { departement: "Alpes-Maritimes", ville: "Nice" },
    "06-PUGET_THENIERS": { departement: "Alpes-Maritimes", ville: "Puget-Theniers" },
    "06-ST_DALMAS_LE_SELVAGE": { departement: "Alpes-Maritimes", ville: "Saint-Dalmas-le-Selvage" },
    "06-ST_ETIENNE_DE_THINEE-AURON": { departement: "Alpes-Maritimes", ville: "Saint-Etienne-de-Tinee" },
    "06-VENCE": { departement: "Alpes-Maritimes", ville: "Vence" },
    "07-TOURNON": { departement: "Ardèche", ville: "Tournon-sur-Rhone" },
    "08-ROCROI": { departement: "Ardennes", ville: "Rocroi" },
    "08-SEDAN": { departement: "Ardennes", ville: "Sedan" },
    "09-ASTRON": { departement: "Ariège", ville: "Aston" },
    "09-AUZAT-PRADIERES": { departement: "Ariège", ville: "Auzat" },
    "09-CONFLANS-SALAU": { departement: "Ariège", ville: "Couflens" },
    "09-L_HOSPITALET_(ANDORRE)": { departement: "Ariège", ville: "L'Hospitalet-pres-l'Andorre" },
    "09-MERENS_LES_VALS": { departement: "Ariège", ville: "Merens-les-Vals" },
    "09-SAINT_GIRONS": { departement: "Ariège", ville: "Saint-Girons" },
    "09-SANTEIN-EYLIE": { departement: "Ariège", ville: "Sentein" },
    "10-ROMILLY": { departement: "Aube", ville: "Romilly-sur-Seine" },
    "11-CARCASSONNE": { departement: "Aude", ville: "Carcassonne" },
    "12-MILLAU": { departement: "Aveyron", ville: "Millau" },
    "13-ISTRES": { departement: "Bouches-du-Rhône", ville: "Istres" },
    "13-PORT_DE_BOUC": { departement: "Bouches-du-Rhône", ville: "Port-de-Bouc" },
    "14-CAEN": { departement: "Calvados", ville: "Caen" },
    "15-AURILLAC": { departement: "Cantal", ville: "Aurillac" },
    "15-CHALVIGNAC_L_AIGLE": { departement: "Cantal", ville: "Chalvignac" },
    "15-FERRIERES_ST_MARY": { departement: "Cantal", ville: "Ferrieres-Saint-Mary" },
    "15-LAFEUILLADE_EN_VEZIE": { departement: "Cantal", ville: "Lafeuillade-en-Vezie" },
    "15-LAVASTRIE_GRANDVAL": { departement: "Cantal", ville: "Lavastrie" },
    "15-LE_CLAUX": { departement: "Cantal", ville: "Le Claux" },
    "15-MARCOLES": { departement: "Cantal", ville: "Marcoles" },
    "15-MARMANHAC": { departement: "Cantal", ville: "Marmanhac" },
    "15-MASSIAC": { departement: "Cantal", ville: "Massiac" },
    "16-ANGOULEME": { departement: "Charente", ville: "Angouleme" },
    "16-COGNAC": { departement: "Charente", ville: "Cognac" },
    "17-LA_ROCHELLE": { departement: "Charente-Maritime", ville: "La Rochelle" },
    "18-BOURGES": { departement: "Cher", ville: "Bourges" },
    "19-BRIVES": { departement: "Corrèze", ville: "Brive-la-Gaillarde" },
    "20-AJACCIO-CAMPO_DEL_ORO": { departement: "Corse-du-Sud", ville: "Ajaccio" },
    "20-ALBERTACCE-POPAJA": { departement: "Haute-Corse", ville: "Albertacce" },
    "20-CALVI_STE_CATHERINE": { departement: "Haute-Corse", ville: "Calvi" },
    "20-CARBINI-MARGHESE": { departement: "Corse-du-Sud", ville: "Carbini" },
    "20-PILA-CANALE": { departement: "Corse-du-Sud", ville: "Pila-Canale" },
    "20-SARTENE-MADONINA": { departement: "Corse-du-Sud", ville: "Sartene" },
    "20-SOLENZARA": { departement: "Corse-du-Sud", ville: "Sari-Solenzara" },
    "21-BAIGNEUX_LES_JUIFS": { departement: "Côte-d'Or", ville: "Baigneux-les-Juifs" },
    "21-DIJON": { departement: "Côte-d'Or", ville: "Dijon" },
    "22-ILE_DE_BREHAT": { departement: "Côtes-d'Armor", ville: "Ile-de-Brehat" },
    "22-ROSTRENEN": { departement: "Côtes-d'Armor", ville: "Rostrenen" },
    "23-GUERET-GRANCHER": { departement: "Creuse", ville: "Gueret" },
    "24-BERGERAC": { departement: "Dordogne", ville: "Bergerac" },
    "25-BESANCON": { departement: "Doubs", ville: "Besancon" },
    "26-MONSEGUR-LAUZON": { departement: "Drôme", ville: "Montsegur-sur-Lauzon" },
    "26-MONTELIMAR": { departement: "Drôme", ville: "Montelimar" },
    "26-NYON": { departement: "Drôme", ville: "Nyons" },
    "27-EVREUX-HUEST": { departement: "Eure", ville: "Evreux" },
    "28-CHARTRES": { departement: "Eure-et-Loir", ville: "Chartres" },
    "29-BREST": { departement: "Finistère", ville: "Brest" },
    "29-FOUESNANT": { departement: "Finistère", ville: "Fouesnant" },
    "30-NIMES": { departement: "Gard", ville: "Nimes" },
    "31-BAGNERES_DE_LUCHON": { departement: "Haute-Garonne", ville: "Bagneres-de-Luchon" },
    "31-TOULOUSE": { departement: "Haute-Garonne", ville: "Toulouse" },
    "31-TOULOUSE-BLAGNAC": { departement: "Haute-Garonne", ville: "Blagnac" },
    "32-AUCH": { departement: "Gers", ville: "Auch" },
    "33-BORDEAUX": { departement: "Gironde", ville: "Bordeaux" },
    "33-CAZAUX": { departement: "Gironde", ville: "La Teste-de-Buch" },
    "34-MONTPELLIER": { departement: "Hérault", ville: "Montpellier" },
    "35-RENNES-ST_JACQUES": { departement: "Ille-et-Vilaine", ville: "Rennes" },
    "36-CHATEAUROUX": { departement: "Indre", ville: "Chateauroux" },
    "37-TOURS": { departement: "Indre-et-Loire", ville: "Tours" },
    "38-ALPES_DE_VENOSC": { departement: "Isère", ville: "Venosc" },
    "38-GRENOBLE-EYBENS": { departement: "Isère", ville: "Grenoble" },
    "38-LA_COTE_ST_ANDRE": { departement: "Isère", ville: "La Cote-Saint-Andre" },
    "38-VIENNE": { departement: "Isère", ville: "Vienne" },
    "39-ST_CLAUDE-ETABLE": { departement: "Jura", ville: "Saint-Claude" },
    "40-MONT_DE_MARSAN": { departement: "Landes", ville: "Mont-de-Marsan" },
    "41-BLOIS": { departement: "Loir-et-Cher", ville: "Blois" },
    "42-ST_ETIENNE-BOUTHEON": { departement: "Loire", ville: "Saint-Etienne" },
    "43-LE_PUY-LOUDES": { departement: "Haute-Loire", ville: "Le Puy-en-Velay" },
    "44-ESCOUBLAC-LA_BAULE": { departement: "Loire-Atlantique", ville: "La Baule-Escoublac" },
    "44-NANTES-CHATEAU_BOUGON": { departement: "Loire-Atlantique", ville: "Nantes" },
    "45-ORLEANS": { departement: "Loiret", ville: "Orleans" },
    "46-GOURDON": { departement: "Lot", ville: "Gourdon" },
    "47-AGEN": { departement: "Lot-et-Garonne", ville: "Agen" },
    "48-MENDE-BRENOUX": { departement: "Lozère", ville: "Mende" },
    "49-ANGERS": { departement: "Maine-et-Loire", ville: "Angers" },
    "50-CHERBOURG": { departement: "Manche", ville: "Cherbourg-Octeville" },
    "51-REIMS": { departement: "Marne", ville: "Reims" },
    "52-CHAUMONT": { departement: "Haute-Marne", ville: "Chaumont" },
    "53-LAVAL-ENTRAMMES": { departement: "Mayenne", ville: "Laval" },
    "54-NANCY-ESSEY": { departement: "Meurthe-et-Moselle", ville: "Essey-les-Nancy" },
    "55-HAUDIOMONT": { departement: "Meuse", ville: "Haudiomont" },
    "56-LORIENT-LANN_BIHOUE": { departement: "Morbihan", ville: "Lorient" },
    "57-METZ-FRESCATY": { departement: "Moselle", ville: "Metz" },
    "58-NEVERS": { departement: "Nièvre", ville: "Nevers" },
    "59-DUNKERQUE": { departement: "Nord", ville: "Dunkerque" },
    "59-LILLE": { departement: "Nord", ville: "Lille" },
    "60-BEAUVAIS-TILLE": { departement: "Oise", ville: "Beauvais" },
    "61-ALENCON": { departement: "Orne", ville: "Alencon" },
    "62-BOULOGNE": { departement: "Pas-de-Calais", ville: "Boulogne-sur-Mer" },
    "63-AUZAT_SUR_ALLIER-LA_COMBELLE": { departement: "Puy-de-Dôme", ville: "Auzat-la-Combelle" },
    "63-CHATEAUNEUF_LES_BAINS": { departement: "Puy-de-Dôme", ville: "Chateauneuf-les-Bains" },
    "63-CLERMONT-FERRAND-AULNAT": { departement: "Puy-de-Dôme", ville: "Clermont-Ferrand" },
    "63-EGLISENEUVE_D_ENGRAYGUES": { departement: "Puy-de-Dôme", ville: "Egliseneuve-d'Entraigues" },
    "63-LE_MONT_DORE": { departement: "Puy-de-Dôme", ville: "Mont-Dore" },
    "63-PICHERANDE": { departement: "Puy-de-Dôme", ville: "Picherande" },
    "63-SAINT_ANTHEME": { departement: "Puy-de-Dôme", ville: "Saint-Antheme" },
    "63-SAINT_NECTAIRE": { departement: "Puy-de-Dôme", ville: "Saint-Nectaire" },
    "63-VIVEROLS": { departement: "Puy-de-Dôme", ville: "Viverols" },
    "64-BIARRITZ": { departement: "Pyrénées-Atlantiques", ville: "Biarritz" },
    "64-LARUNS": { departement: "Pyrénées-Atlantiques", ville: "Laruns" },
    "64-PAU": { departement: "Pyrénées-Atlantiques", ville: "Pau" },
    "65-GEDRE": { departement: "Hautes-Pyrénées", ville: "Gedre" },
    "65-LASSOULA": { departement: "Hautes-Pyrénées", ville: "Loudenvielle" },
    "65-TARBES_OSSUN": { departement: "Hautes-Pyrénées", ville: "Tarbes" },
    "66-FONT_ROMEU": { departement: "Pyrénées-Orientales", ville: "Font-Romeu-Odeillo-Via" },
    "66-PERPIGNAN": { departement: "Pyrénées-Orientales", ville: "Perpignan" },
    "66-PRATS_DE_MOLLO": { departement: "Pyrénées-Orientales", ville: "Prats-de-Mollo-la-Preste" },
    "67-STRASBOURG_ENTZHEIM": { departement: "Bas-Rhin", ville: "Strasbourg" },
    "68-COLMAR-MEYENHEIM": { departement: "Haut-Rhin", ville: "Colmar" },
    "69-LYON": { departement: "Rhône", ville: "Lyon" },
    "70-LUXEUIL": { departement: "Haute-Saône", ville: "Luxeuil-les-Bains" },
    "71-CHALON_SUR_SAONE": { departement: "Saône-et-Loire", ville: "Chalon-sur-Saone" },
    "71-LA_GUICHE": { departement: "Saône-et-Loire", ville: "La Guiche" },
    "71-MACON": { departement: "Saône-et-Loire", ville: "Macon" },
    "71-MONT_ST_VINCENT": { departement: "Saône-et-Loire", ville: "Mont-Saint-Vincent" },
    "72-LE_MANS": { departement: "Sarthe", ville: "Le Mans" },
    "73-CHALLES-LES-EAUX": { departement: "Savoie", ville: "Challes-les-Eaux" },
    "74-ANNECY": { departement: "Haute-Savoie", ville: "Annecy" },
    "74-ANNEMASSE": { departement: "Haute-Savoie", ville: "Annemasse" },
    "74-THONON-LES-BAINS": { departement: "Haute-Savoie", ville: "Thonon-les-Bains" },
    "74-USINENS": { departement: "Haute-Savoie", ville: "Usinens" },
    "75-PARIS-MONTSOURIS": { departement: "Île-de-France", ville: "Paris" },
    "75-PARIS-TOUR_ST_JACQUES": { departement: "Île-de-France", ville: "Paris" },
    "76-CAP_DE_LA_HEVE": { departement: "Seine-Maritime", ville: "Le Havre" },
    "76-ROUEN": { departement: "Seine-Maritime", ville: "Rouen" },
    "77-MELUN": { departement: "Seine-et-Marne", ville: "Melun" },
    "78-TRAPPES": { departement: "Yvelines", ville: "Trappes" },
    "79-NIORT": { departement: "Deux-Sèvres", ville: "Niort" },
    "80-ABBEVILLE": { departement: "Somme", ville: "Abbeville" },
    "81-ALBI": { departement: "Tarn", ville: "Albi" },
    "82-MONTAUBAN": { departement: "Tarn-et-Garonne", ville: "Montauban" },
    "83-BRIGNOLES": { departement: "Var", ville: "Brignoles" },
    "83-COLLOBRIERES": { departement: "Var", ville: "Collobrieres" },
    "83-DRAGUIGNAN": { departement: "Var", ville: "Draguignan" },
    "83-PLAN_D_AUPS": { departement: "Var", ville: "Plan-d'Aups-Sainte-Baume" },
    "84-APT": { departement: "Vaucluse", ville: "Apt" },
    "84-AVIGNON-MONTFAVET": { departement: "Vaucluse", ville: "Avignon" },
    "84-CAVAILLON": { departement: "Vaucluse", ville: "Cavaillon" },
    "84-GORDES": { departement: "Vaucluse", ville: "Gordes" },
    "85-LES_SABLES_D_OLONNES": { departement: "Vendée", ville: "Les Sables-d'Olonne" },
    "86-POITIERS": { departement: "Vienne", ville: "Poitiers" },
    "87-LIMOGES": { departement: "Haute-Vienne", ville: "Limoges" },
    "88-EPINAL": { departement: "Vosges", ville: "Epinal" },
    "89-AUXERRE": { departement: "Yonne", ville: "Auxerre" },
    "90-BELFORT": { departement: "Territoire de Belfort", ville: "Belfort" },
    "91-BRETIGNY_SUR_ORGE": { departement: "Essonne", ville: "Bretigny-sur-Orge" },
    "91-ORLY": { departement: "Val-de-Marne", ville: "Orly" },
    "92-NANTERRE": { departement: "Hauts-de-Seine", ville: "Nanterre" },
    "93-ST-DENIS": { departement: "Seine-Saint-Denis", ville: "Saint-Denis" },
    "94-CRETEIL": { departement: "Val-de-Marne", ville: "Creteil" },
    "95-LE_BOURGET": { departement: "Seine-Saint-Denis", ville: "Le Bourget" },
    "95-PONTOISE_CORMELLES": { departement: "Val-d'Oise", ville: "Pontoise" },
};

/**
 * Patches a parsed etude JSON object when ville/departement are missing
 * by looking up the old `city` station name in the mapping.
 * Mutates and returns the json object.
 */
export function patchMissingLocation(json: any): any {
    if (!json) return json;

    const srb = json.solutionRequestBody;
    if (srb?.ville && srb?.departement && json.departement && json.city) return json;

    const city = srb?.ville || json.city;
    if (!city) return json;

    // Normalize: remove spaces around the first dash to match mapping keys
    const normalizedKey = city
        .trim()
        .replace(/^(\d{2})\s*[-_]\s*/, "$1-")  // normalize dept prefix separator
        .replace(/\s*-\s*/g, "-")               // remove spaces around dashes
        .replace(/\s+/g, "_")                   // spaces to underscores
        .replace(/'/g, "_")                     // apostrophes to underscores
        .replace(/\//g, "-")                    // slashes to dashes
        .toUpperCase()
        .normalize("NFD")
        .replace(/[\u0300-\u036f]/g, "");       // strip accent marks
    const mapped = STATION_MAPPING[normalizedKey];
    if (!mapped) return json;

    json.departement = mapped.departement;
    json.city = mapped.ville;

    if (!json.solutionRequestBody) {
        json.solutionRequestBody = {};
    }
    json.solutionRequestBody.departement = mapped.departement;
    json.solutionRequestBody.ville = mapped.ville;

    return json;
}

export default STATION_MAPPING;
